import * as z from 'zod';

import { priceFrequencyQueryLinkerSchema } from '@/_pages/settings/price-frequencies/shared/schemas/price-frequency-query-linker-schema';
import { productAndServicesQueryLinkerSchema } from '@/_pages/settings/products-and-services-templates/shared/schemas/products-and-services/product-services-query-linker-schema';
import { booleanFormSchema, currencyInput } from '@/_schemas/generic';

import { clientOptFormSchema } from './client-opt-schema';
import { deliverablesQuerySchema } from './deliverables-query-schema';

import { deliverableWholesalePriceFormSchema } from '../wholesale-prices';

export const deliverablesFormSchema = deliverablesQuerySchema
  .omit({ client_opt: true, price_frequency_id: true, product_id: true })
  .extend({
    client_opt: clientOptFormSchema,
    price_frequency: priceFrequencyQueryLinkerSchema.refine((val) => val.id !== -1, {
      message: 'Price Frequency is required',
    }),
    product: productAndServicesQueryLinkerSchema
      .nullable()
      .refine((val) => val?.id !== -1, { message: 'Product is required' }),

    quantity: currencyInput.formSchema(),
    // numeric string
    price: currencyInput.formSchema(),

    opted_in: booleanFormSchema(),
    opted_out: booleanFormSchema(),

    description: z.string(),
    deliverable_wholesale_price: z.array(deliverableWholesalePriceFormSchema),
  });

export type DeliverablesFormSchema = z.infer<typeof deliverablesFormSchema>;
